import * as React from "react";
import {useState} from "react";
import RadioButtons from "../../../../../../../../ui/radiobutton/radiobutton";
import {RadioButton} from "../../../../../../../../modals/types/radiobutton";
import "./tab3.scss";
import PostSlider from "../../../../../../../../ui/slider/postslider/postslider";
import Post from "../../../../../../../../ui/post/post";
import MultiSelectDropzone, {choosedFile} from "../../../../../../../../ui/dropzone/multiselect/multielectdropzone";

const Tab3 = () => {
    const showCommentContent: RadioButton[] = [
        {label: "کامنت باز باشد", currentValue: "O"},
        {label: "کامنت بسته باشد", currentValue: "C"}
    ]
    const [selectedFiles, setSelectedFiles] = useState<choosedFile[]>([]);
    const [commentStatus, setCommentStatus] = useState('O');
    return (
        <div className="Tab3">
            <div className="row">
                <div className="col-lg-6 col-12 mb-3">
                    <div className="row">
                        <div className="col-12 mb-3">
                            <MultiSelectDropzone setSelectedImages={setSelectedFiles}/>
                            <p className="gray-text font-light pt-2">
                                &#x2022;&nbsp;&nbsp;&nbsp;&nbsp;
                                فرمت عکس png, jpg باشد و حداکثر ۲۰ مگابایت باشد
                            </p>
                        </div>
                        <div className="col-12 mb-3">
                            <h6 className="pt-1 pb-1">تگ روی عکس</h6>
                            <input type="text" name="" id="" className="Campaign-Input"
                                   placeholder="مثال: کمپین روز مادر"/>
                        </div>
                        <div className="col-12 mb-3">
                            <h6 className="pt-4 pb-1">ملاحظات انتشار</h6>
                            <textarea name="" id="" className="Campaign-Input" placeholder="بنویسید ..." cols={10}
                                      rows={4}></textarea>
                        </div>
                        <div className="col-12 mb-3 mt-3">
                            <h6 className="mb-3 pt-1 font-light">وضعیت کامنت</h6>
                            <RadioButtons items={showCommentContent} value={commentStatus} setValue={setCommentStatus}/>
                        </div>
                    </div>
                </div>
                <div className="col-lg-6 col-12 mb-3">
                    <Post>
                        <PostSlider images={selectedFiles}/>
                    </Post>
                </div>
            </div>
        </div>
    );
}

export default Tab3;